module.exports = __webpack_public_path__ + "img/bt.374a915f.svg";